import React from 'react';
import { X, Crown, Lock, Sparkles, Check, ArrowRight, Shield } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export default function TierGateModal() {
  const { tierGateOpen, setTierGateOpen, tierGateFeature, isAuthenticated, openAuth } = useAuth();

  if (!tierGateOpen) return null;

  const handleAction = () => {
    setTierGateOpen(false);
    if (!isAuthenticated) {
      openAuth('register');
    } else {
      // In future can open payment/contact dialog; for now show contact or alert
      alert('Để nâng cấp tài khoản lên gói PRO / VIP, vui lòng liên hệ Quản trị viên hệ thống hoặc Admin qua Telegram.');
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/85 backdrop-blur-md p-4 animate-fadeIn">
      <div className="bg-slate-900 border border-amber-500/40 rounded-2xl w-full max-w-md overflow-hidden shadow-2xl flex flex-col font-sans relative">
        
        {/* Top Gradient Banner */}
        <div className="h-1.5 w-full bg-gradient-to-r from-amber-500 via-cyan-400 to-purple-500" />

        {/* Header */}
        <div className="flex items-center justify-between px-6 pt-5 pb-3 border-b border-slate-800">
          <div className="flex items-center gap-2.5">
            <div className="p-2 rounded-xl bg-amber-500/20 text-amber-400 border border-amber-500/30">
              <Crown className="w-5 h-5" />
            </div>
            <div>
              <h3 className="text-sm font-bold text-slate-100 flex items-center gap-2">
                NÂNG CẤP GÓI {tierGateFeature.requiredTier || 'PRO'}
              </h3>
              <p className="text-[11px] text-slate-400">Mở khóa tính năng chuyên sâu cao cấp</p>
            </div>
          </div>
          <button
            onClick={() => setTierGateOpen(false)}
            className="p-1.5 rounded-lg text-slate-400 hover:text-slate-200 hover:bg-slate-800 transition cursor-pointer"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4">
          <div className="p-4 rounded-xl bg-amber-950/20 border border-amber-500/30 text-center space-y-2">
            <div className="w-12 h-12 rounded-2xl bg-amber-500/20 border border-amber-500/40 text-amber-400 flex items-center justify-center mx-auto">
              <Lock className="w-6 h-6" />
            </div>
            <h4 className="text-sm font-bold text-slate-100">
              Tính năng: <span className="text-amber-400">{tierGateFeature.name || 'Chiến Lược Nâng Cao'}</span>
            </h4>
            <p className="text-xs text-slate-300">
              Tính năng này yêu cầu cấp bậc tài khoản tối thiểu là{' '}
              <strong className="text-amber-400 font-bold">{tierGateFeature.requiredTier || 'PRO 👑'}</strong>.
            </p>
          </div>

          <div className="space-y-2">
            <span className="text-[10px] uppercase font-bold text-slate-400 tracking-wider block">
              QUYỀN LỢI ĐẶC QUYỀN GÓI PRO VIP:
            </span>
            <div className="space-y-1.5 text-xs text-slate-200">
              <div className="flex items-center gap-2">
                <Check className="w-4 h-4 text-emerald-400 shrink-0" />
                <span>Deep Backtest lên đến <strong>50,000 nến M1 - D1</strong></span>
              </div>
              <div className="flex items-center gap-2">
                <Check className="w-4 h-4 text-emerald-400 shrink-0" />
                <span>Trình soạn thảo Pine Script v5 Editor độc quyền</span>
              </div>
              <div className="flex items-center gap-2">
                <Check className="w-4 h-4 text-emerald-400 shrink-0" />
                <span>Nhận cảnh báo tín hiệu tự động qua <strong>Telegram Bot</strong></span>
              </div>
              <div className="flex items-center gap-2">
                <Check className="w-4 h-4 text-emerald-400 shrink-0" />
                <span>Theo dõi và kích hoạt không giới hạn chiến lược SMC Matrix</span>
              </div>
            </div>
          </div>

          <button
            onClick={handleAction}
            className="w-full py-2.5 rounded-xl bg-gradient-to-r from-amber-500 to-amber-400 hover:from-amber-400 hover:to-amber-300 text-slate-950 font-bold text-xs transition cursor-pointer shadow-lg shadow-amber-500/20 flex items-center justify-center gap-2"
          >
            <span>{!isAuthenticated ? 'Đăng Ký Tài Khoản Miễn Phí' : 'Nâng Cấp Ngay Lên PRO 👑'}</span>
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>

        {/* Footer */}
        <div className="px-6 py-3 bg-slate-950/60 border-t border-slate-800 text-[11px] text-slate-400 flex items-center justify-between">
          <span>Kích hoạt tự động & linh hoạt</span>
          <button
            onClick={() => setTierGateOpen(false)}
            className="text-slate-400 hover:text-slate-200 underline cursor-pointer"
          >
            Để sau
          </button>
        </div>
      </div>
    </div>
  );
}
